import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Text,
} from "@chakra-ui/react";

const DeactivateModal = ({ isOpen, onClose, onConfirm, data }) => {
    if (!data) return null;

    const isActivating = data.data?.isActive === false;
    const actionLabel = isActivating ? "Activate" : "Deactivate";

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{actionLabel} {data.type}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text>
                        Are you sure you want to {actionLabel.toLowerCase()} <b>{data.data?.name || "this item"}?</b>
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme={isActivating ? "green" : "red"} mr={3} onClick={onConfirm}>{actionLabel}</Button>
                    <Button onClick={onClose}>Povratak</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeactivateModal;
